import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";
import { DateTimeInput } from "@/lib/Components/Form/Inputs/DateTimeInput";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createCallbackLeadMutation } from "@/app/CallbackLeads/GraphQL/callbackLeadMutations";
import { CreateCallbackLeadInput } from "@/gql/graphql";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { z } from "zod";
import { useTranslations } from "use-intl";

const createCallbackValidation = z.object({
  name: z.string().min(2).max(255),
  phone: z.string().min(5).max(255),
  email: z.string().email().max(255).nullish().or(z.literal("")),
  note: z.string().max(1000).nullish(),
});

export function CallbackLeadCreateDialog() {
  const { close } = useDialogState();
  const t = useTranslations("callbackLead");
  const { mutateAsync } = useGqlMutation(createCallbackLeadMutation);

  return (
    <BaseDialog title={t("createDialog.title")} size="xl">
      <GenericForm<CreateCallbackLeadInput>
        validationSchema={toFormikValidationSchema(createCallbackValidation)}
        initialValues={{
          name: "",
          phone: "",
          email: "",
          note: "",
          call_back_at: null,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            input: {
              ...values,
              email: values.email ? values.email : null,
              note: values.note ? values.note : null,
              call_back_at: values.call_back_at ? values.call_back_at : null,
            },
          });
          await close();
        }}
      >
        <TextInput
          name="name"
          label={t("createDialog.name")}
          className="col-span-full"
          autoFocus
        />
        <TextInput
          name="phone"
          label={t("createDialog.phone")}
          className="col-span-full sm:col-span-6"
        />
        <TextInput
          name="email"
          label={t("createDialog.email")}
          className="col-span-full sm:col-span-6"
          optionalLabel
        />
        <DateTimeInput
          name="call_back_at"
          label={t("createDialog.callBackAt")}
          description={t("createDialog.callBackAtDescription")}
          className="col-span-full"
        />
        <TextAreaInput
          name="note"
          label={t("createDialog.note")}
          className="col-span-full"
          optionalLabel
        />
        <DialogSubmitButton text={t("createDialog.submit")} />
      </GenericForm>
    </BaseDialog>
  );
}
